import { render, staticRenderFns } from "./RouteTemplateTimeLabelTab.vue?vue&type=template&id=4cd88d4e&scoped=true&"
import script from "./RouteTemplateTimeLabelTab.vue?vue&type=script&lang=js&"
export * from "./RouteTemplateTimeLabelTab.vue?vue&type=script&lang=js&"
import style0 from "./RouteTemplateTimeLabelTab.vue?vue&type=style&index=0&id=4cd88d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd88d4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VForm,VRow,VSpacer})
